import { render } from "./ChooseFilesModal.vue?vue&type=template&id=63b9e906"
import script from "./ChooseFilesModal.vue?vue&type=script&lang=ts"
export * from "./ChooseFilesModal.vue?vue&type=script&lang=ts"

import "./ChooseFilesModal.vue?vue&type=style&index=0&id=63b9e906&lang=scss"
script.render = render

export default script